export type FormTypeKind = 'normal' | 'prefilled' | 'conditional'

export const getFormTypeLabel = (form?: {
  isPrefillForm?: boolean
  prefillRequiresApproval?: boolean
}): string => {
  if (!form?.isPrefillForm) return 'Basic'
  if (form.prefillRequiresApproval === false) return 'Conditional'
  return 'Prefilled'
}

export const getFormTypeBadgeClass = (form?: {
  isPrefillForm?: boolean
  prefillRequiresApproval?: boolean
}): string => {
  if (!form?.isPrefillForm) return 'bg-secondary'
  if (form.prefillRequiresApproval === false) return 'bg-primary'
  return 'bg-info'
}

/** Prefilled forms that require admin approve/reject on edited fields. */
export const prefillApprovalRequired = (form?: {
  isPrefillForm?: boolean
  prefillRequiresApproval?: boolean
}): boolean => form?.isPrefillForm === true && form?.prefillRequiresApproval !== false

/** Excel distribution + prefill settings (both prefilled variants). */
export const isPrefillDistributionForm = (form?: { isPrefillForm?: boolean }): boolean =>
  form?.isPrefillForm === true

export const formTypeFromRecord = (form?: {
  isPrefillForm?: boolean
  prefillRequiresApproval?: boolean
}): FormTypeKind => {
  if (!form?.isPrefillForm) return 'normal'
  if (form.prefillRequiresApproval === false) return 'conditional'
  return 'prefilled'
}
